import { Charts } from './Charts';
import CausesCondictionsChartsDataProvider from './contexts/CausesCondictionsChartsDataContext';

const CausesCondictionsWrapper = () => {
    return (
        <CausesCondictionsChartsDataProvider>
            <Charts />
        </CausesCondictionsChartsDataProvider>
    );
};

export default CausesCondictionsWrapper;
